// extracted by mini-css-extract-plugin
module.exports = {"mobileBankAccount":"styles_mobileBankAccount__1SpMQ"};